import axios from 'axios';
import moment from 'moment';
import { parentAccountApi } from '@atheneum/api';
import { get } from 'lodash';
export const translate = async (string, language) => {
  // TODO setup atheneum-offline's REACT_APP_TRANSLATE_URL variable. should be parsing-service's /translate endpoint
  return axios({
    url: `${process.env.REACT_APP_TRANSLATE_URL}?q=${string}&t=${language}&s=en`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
};
export const getEmployeeSubmitted = async availabilityStore => {
  const result = await axios({
    method: 'get',
    url: `/api/expert-project-link/${availabilityStore.epl.id}/employee-submitted`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  const pAccount = await parentAccountApi.get(availabilityStore.project.parentAccountId);
  const {
    HEDGE_FUND
  } = availabilityStore.staticData.CONST.ACCOUNT_TYPES;
  const hfDisclaimer = '<p><i>Atheneum thanks you for your participation in today’s consultation. Before we begin, we would like to remind you that you are not to disclose any material non-public information, or any confidential information, concerning your company or any other company discussed today. If at any time, a question is asked that touches on an area where you do have confidential information, please decline to answer. If you are unsure as to whether or not you may be breaching any obligation to a third party by disclosing a piece of information, please err on the side of caution and kindly decline to answer the question.</i></p>';
  const employeeSubmitted = result.data;
  const employeePositionIdForExpert = employeeSubmitted.currentPosition.employeePositionId;
  const userPositionForExpert = availabilityStore.staticData.names.employeePositions[employeePositionIdForExpert] || '';
  const userPhonesForExpert = get(employeeSubmitted, 'address.phones', []);
  const userPhoneNumbersForExpert = userPhonesForExpert.map(phone => phone.phoneNum);
  const employee = `${employeeSubmitted.fullName}<br>
      ${userPositionForExpert}<br>
      ${employeeSubmitted.email}<br>
      ${userPhoneNumbersForExpert.join('<br>')}<br>
      ${pAccount.disclaimerComment || ''}
      ${pAccount.accountTypeId === HEDGE_FUND && pAccount.hedgeFundRequired ? hfDisclaimer : ''}`;
  return employee;
};
export const getTakenExpertSlots = async availabilityStore => {
  const dateString = 'T00:00:00.000Z';
  const start = moment().subtract(1, 'days').format('YYYY-MM-DD');
  const end = moment().add(1, 'y').format('YYYY-MM-DD');
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/expert-availability-to-epl/${availabilityStore.epl.expert.id}/taken-slots?startTime=${start + dateString}&endTime=${end + dateString}&eplId=${availabilityStore.epl.id}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const getEmailTemplate = async templateId => {
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/email-template/${templateId}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const getExpert = async id => {
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/expert/${id}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const getClientContact = async availabilityStore => {
  const project = availabilityStore.project || availabilityStore.epl && availabilityStore.epl.project;
  if (!project) throw new Error('Could not fetch client contacts.');
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/parent-account/${project.parentAccountId}/clients`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const getProjectClients = async projectId => {
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/project/${projectId}/clients`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const getExpertLanguage = async id => {
  const data = await axios({
    method: 'get',
    url: `/api/expert/${id}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const updateScheduleByEplId = async (eplId, data) => {
  const res = await axios({
    method: 'post',
    url: `/api/expert-project-link/${eplId}/schedule`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    },
    data: data
  });
  return res;
};
export const getEmailTemplateByGroup = async groupName => {
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/email-template/group/${groupName}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  return data;
};
export const getMasterTemplate = async payload => {
  const {
    data
  } = await axios({
    method: 'POST',
    url: `/api/email-template/master`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    },
    data: payload
  });
  return data;
};
export const submitSchedule = async scheduleData => {
  const url = process.env.REACT_APP_CALENDAR_SERVICE_URL;
  const {
    data
  } = await axios({
    url,
    method: 'POST',
    headers: {
      authorization: localStorage.getItem('ngStorage-accessToken')
    },
    data: scheduleData
  });
  return data;
};
export const scheduleOnCapi = async scheduleData => {
  const data = await axios({
    method: 'post',
    url: `${process.env.REACT_APP_CAPI_SERVICE_URL}/calls/schedule`,
    headers: {
      authorization: localStorage.getItem('ngStorage-accessToken')
    },
    data: scheduleData
  });
  return data;
};
export const updateCallOnCapi = async updateData => {
  const data = await axios({
    method: 'post',
    url: `${process.env.REACT_APP_CAPI_SERVICE_URL}/calls/update`,
    headers: {
      authorization: localStorage.getItem('ngStorage-accessToken')
    },
    data: updateData
  });
  return data;
};